<template>
  <div id="pop" v-if="landDetatilPopShow" style="left: 180px; bottom: 90px">
    <div class="popTitle">地块信息</div>
    <i class="el-icon-error closePop" @click="closeFun"></i>
    <div class="popList">
      <div class="popItem">
        <div class="popText">地块编号：</div>
        <el-tooltip
          class="item"
          effect="light"
          v-if="popupObj.landNo.length > 15"
          :content="popupObj.landNo"
          placement="top"
        >
          <div class="popdec">{{ popupObj.landNo }}</div>
        </el-tooltip>
        <div class="popdec" v-else>{{ popupObj.landNo }}</div>
      </div>
      <div class="popItem">
        <div class="popText">权属单位：</div>
        <el-tooltip
          class="item"
          effect="light"
          v-if="popupObj.villageName.length > 10"
          :content="popupObj.villageName"
          placement="top"
        >
          <div class="popdec">{{ popupObj.villageName }}</div>
        </el-tooltip>
        <div class="popdec" v-else>{{ popupObj.villageName }}</div>
      </div>
      <div class="popItem">
        <div class="popText">地块面积：</div>

        <div class="popdec">{{ popupObj.area.toFixed(2) }}（亩）</div>
      </div>
      <div class="popItem">
        <div class="popText">土壤类型：</div>
        <el-tooltip
          class="item"
          effect="light"
          :content="popupObj.soilType"
          placement="top"
        >
          <div class="popdec">{{ popupObj.soilType }}</div>
        </el-tooltip>
      </div>
      <div class="popItem">
        <div class="popText">耕地质量等级：</div>

        <div class="popdec">{{ popupObj.landQualityCn }}</div>
      </div>
      <div class="popItem">
        <div class="popText">作物类型：</div>
        <el-tooltip
          class="item"
          effect="light"
          v-if="popupObj.cropType.length > 10"
          :content="popupObj.cropType"
          placement="top"
        >
          <div class="popdec">{{ popupObj.cropType }}</div>
        </el-tooltip>
        <div class="popdec" v-else>{{ popupObj.cropType }}</div>
      </div>
      <div class="popItem">
        <div class="popText">土壤有机质：</div>

        <div class="popdec">
          {{ popupObj.organicMatter.toFixed(2) }}（g/kg）
        </div>
      </div>
      <div class="popItem">
        <div class="popText">土壤pH值：</div>

        <div class="popdec">{{ popupObj.ph.toFixed(2) }}</div>
      </div>
      <div class="popItem">
        <div class="popText">土壤全氮：</div>

        <div class="popdec">{{ popupObj.nitrogen.toFixed(2) }}（g/kg）</div>
      </div>
      <div class="popItem">
        <div class="popText">土壤有效磷：</div>

        <div class="popdec">{{ popupObj.phosphorus.toFixed(2) }}（mg/kg）</div>
      </div>
      <div class="popItem">
        <div class="popText">土壤速效钾：</div>
        <div class="popdec">{{ popupObj.potassium.toFixed(2) }}（mg/kg）</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandPopup",
  props: {
    popupObj: Object,
    landDetatilPopShow: {
      type: Boolean,
      default: false,
    },
    closeFun: {
      type: Function,
      default: {},
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>